import { render, staticRenderFns } from "./customize_info.vue?vue&type=template&id=03dca241&scoped=true"
import script from "./customize_info.vue?vue&type=script&lang=js"
export * from "./customize_info.vue?vue&type=script&lang=js"
import style0 from "./customize_info.vue?vue&type=style&index=0&id=03dca241&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dca241",
  null
  
)

export default component.exports